import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { LoginLayout } from '@/components/modules/Layout/LoginLayout';
import { RegistrationForm } from '@/components/modules/pages/registration/form/RegistrationForm';
export const RegistrationView = (props) => {
    const { className = '', customErrorCallback, onSubmit } = props;
    return (_jsx(LoginLayout, Object.assign({ className: className, title: '新規登録申請' }, { children: _jsx(RegistrationForm, { className: 'p-32', customErrorCallback: customErrorCallback, onSubmit: onSubmit }) })));
};
